export default __webpack_public_path__ + "static/Hasan-cd1451650a93ecc8473f05d26940fac1fcc375123ac851c9016363db84c21ae4.svg";